export default __webpack_public_path__ + "static/testimonials-bg-tl-2d6a3db059405342ff5418dbf1ca760e.svg";